import { useRef } from "react";

const usePrevious = <T>(value: T, ignoreValues: T[]) => {
  const currentRef = useRef(value);
  const previousRef = useRef<T>();

  if (currentRef.current !== value) {
    if (!ignoreValues.includes(value)) {
      previousRef.current = currentRef.current;
    }

    if (!ignoreValues.includes(value)) {
      currentRef.current = value;
    }
  }

  return previousRef;
};

export default usePrevious;
